import axios from 'axios';
import { errorGenerator } from 'lib/errorGenerator';
import { generatoreCode } from 'lib/generateCode';
import { getBaseUrl } from 'lib/launchStrategies/helpers';

export async function workspacePostCall(id) {
  const data = { id: id };
  console.log('getBaseUrl: ' + getBaseUrl());
  console.log('data workspacePostCall: ' + JSON.stringify(data));
  await axios
    .post(`${getBaseUrl()}/rqx/session/workspace`, {
      data,
    })
    .then(function () {
      window.location.replace(getBaseUrl());
      // setTimeout(() => {
      //   console.log('try to reload to ' + window.location);
      //   window.location.reload();
      // }, 100);
    })
    .catch(function (error) {
      console.log(error);
      const errorCode = generatoreCode(8).toString();
      errorGenerator('workspacePostCall failure', error);
      errorGenerator(
        errorCode,
        error,
        'workspacePostCall failure',
        'Errore durante la POST, dopo aver scelto il workspace',
      );
    });
}
